import { Typography, styled } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import React from "react";

interface IWrapperProps {
  $leftProgress: number;
  $mainColor: string;
  $completionColor: string;
}

const Wrapper = styled("div")<IWrapperProps>`
  border: 1px solid ${props => (props.$leftProgress === 0 ? props.$completionColor : props.$mainColor)};
  border-radius: ${props => props.theme.modernButtonBorderRadius}px;
  box-shadow: 0px 0px 0px 1px
    ${props => (props.$leftProgress === 100 ? props.$completionColor : props.$mainColor)} inset;
  height: 30px;
  overflow: hidden;
  position: relative;
  width: 100%;

  & [data-smartrr-bar-bg] {
    background-color: ${props => (props.$leftProgress === 0 ? props.$completionColor : props.$mainColor)};
    height: 100%;
    left: ${props => props.$leftProgress}%;
    position: absolute;
    top: 0px;
    transition: left 1s ease-in-out;
    width: 100%;
    border-radius: ${props => props.theme.modernButtonBorderRadius}px;
  }
`;
interface Props {
  steps: number;
  progress: number;
  config: {
    mainColor?: string;
    completionColor?: string;
    completionText?: string;
  };
}

export const ProgressBar = ({
  steps,
  progress,
  config = {
    mainColor: "#f6c978",
    completionColor: "#7673D2",
  },
}: Props) => {
  const increments = 100 / steps;
  const leftProgress = progress * increments - 100;
  return (
    <Wrapper
      $leftProgress={leftProgress}
      $completionColor={config.completionColor!}
      $mainColor={config.mainColor!}
      data-testid="tiers-progress-bar"
      className={prefixClassName("progress-bar")}
    >
      {leftProgress === 0 && config.completionText ? (
        <Typography
          variant="body1"
          sx={{
            color: "#fff",
            fontSize: "14px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            zIndex: "1",
          }}
        >
          {config.completionText}
        </Typography>
      ) : (
        <React.Fragment />
      )}
      <span data-smartrr-bar-bg></span>
    </Wrapper>
  );
};
